var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-3", autocomplete: "off" },
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
          }
        }
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-9" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label:
                    "Documento Principal (Si piensa firmar\n          electrónicamente no debe ser escaneado) (*)",
                  name: "mainFileName",
                  readonly: "",
                  danger: _vm.errors.has("step-3.mainFileName"),
                  "danger-text": _vm.errors.first("step-3.mainFileName"),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.step.mainFile.name,
                  callback: function($$v) {
                    _vm.$set(_vm.step.mainFile, "name", $$v)
                  },
                  expression: "step.mainFile.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 d-flex align-items-end" },
            [
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  accept: ".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc",
                  text: "Seleccionar",
                  "max-size-in-mb": 30,
                  "upload-to": "ed",
                  "button-class": {
                    "btn-block": true,
                    "mb-5": _vm.errors.has("step-3.mainFileName")
                  },
                  "container-class": "w-100"
                },
                model: {
                  value: _vm.step.mainFile,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "mainFile", $$v)
                  },
                  expression: "step.mainFile"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-md-12" }, [
            _vm.error.message !== ""
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                    staticStyle: { height: "32px" }
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(" " + _vm._s(_vm.error.message) + " ")
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-9" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  label: "Archivo Adjunto",
                  name: "additionalFileName",
                  readonly: "",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.additionalFile.name,
                  callback: function($$v) {
                    _vm.$set(_vm.additionalFile, "name", $$v)
                  },
                  expression: "additionalFile.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 d-flex align-items-end" },
            [
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  text: "Seleccionar",
                  accept: ".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc",
                  "upload-to": "ed",
                  "max-size-in-mb": 30,
                  "button-class": "btn-block",
                  "container-class": "w-100"
                },
                on: {
                  input: function($event) {
                    return _vm.addAdditionalFile()
                  }
                },
                model: {
                  value: _vm.additionalFile,
                  callback: function($$v) {
                    _vm.additionalFile = $$v
                  },
                  expression: "additionalFile"
                }
              })
            ],
            1
          )
        ]),
        Object.keys(_vm.step.mainFile).length
          ? _c(
              "div",
              { staticClass: "row mb-3" },
              [
                _c("div", { staticClass: "col-3" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column align-items-center" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "description",
                          size: "75px",
                          color: "primary"
                        }
                      }),
                      _c(
                        "b",
                        { staticClass: "text-truncate w-100 text-center" },
                        [_vm._v(_vm._s(_vm.step.mainFile.name))]
                      )
                    ],
                    1
                  )
                ]),
                _vm._l(_vm.step.additionalFiles, function(file) {
                  return _c("div", { key: file.id, staticClass: "col-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column align-items-center" },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "description",
                            size: "75px",
                            color: "primary"
                          }
                        }),
                        _c(
                          "b",
                          { staticClass: "text-truncate w-100 text-center" },
                          [_vm._v(_vm._s(file.name))]
                        ),
                        file.type !== "respuesta"
                          ? _c("vs-button", {
                              attrs: {
                                color: "danger",
                                type: "flat",
                                icon: "clear"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeAdditionalFile(file.id)
                                }
                              }
                            })
                          : _vm._e(),
                        file.type === "respuesta"
                          ? _c(
                              "b-badge",
                              {
                                staticClass: "mr-2",
                                attrs: { variant: "light-info" }
                              },
                              [_vm._v(" respuesta ")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Adjuntar Documento")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }